/**
 * Los umbrales del semáforo de ratios financieros, en UN SOLO SITIO.
 *
 * Vivían en `apps/api/src/lib/accounting/kpis.ts` y estaban COPIADOS a mano en
 * `apps/web/src/lib/ratio-insight.ts`, que es quien redacta la frase que
 * explica el ratio. El backend decidía el color y la pantalla el texto con los
 * mismos números escritos dos veces: tocar uno y olvidar el otro dejaba la
 * tarjeta diciendo «holgado» en rojo. Hoy coincidían; era cuestión de tiempo.
 *
 * Están aquí, en `@toga/shared`, porque es el único paquete que ven los dos.
 */
export const SEMAFORO_RULES = {
    liquidezCorriente: {
        minGreen: 1.5,
        maxGreen: 2.2,
        // Amarillo en [1.0, 1.5) ∪ (2.2, +∞). Modelamos la segunda banda con
        // extraYellow; la inferior con [1.0, 1.5).
        minYellow: 1.0,
        maxYellow: 1.4999999,
        extraYellow: { min: 2.2000001, max: Infinity },
    },
    pruebaAcida: {
        minGreen: 0.9,
        maxGreen: 1.2,
        minYellow: 0.6,
        maxYellow: 0.8999999,
    },
    // Fondo de maniobra: green > 0, red <= 0 (sin amarillo). Lo modelamos como
    // green ∈ (0, +∞], red en cualquier otro caso.
    fondoManiobra: {
        minGreen: 0.0000001,
        maxGreen: Infinity,
    },
    // Endeudamiento (PT/PN): green [0.4, 0.6], yellow [0.2, 0.4) ∪ (0.6, 0.8],
    // red < 0.2 o > 0.8.
    endeudamiento: {
        minGreen: 0.4,
        maxGreen: 0.6,
        minYellow: 0.2,
        maxYellow: 0.3999999,
        extraYellow: { min: 0.6000001, max: 0.8 },
    },
    // Calidad de la deuda (PC/PT): green <= 0.3, yellow (0.3, 0.5], red > 0.5.
    calidadDeuda: {
        minGreen: 0,
        maxGreen: 0.3,
        minYellow: 0.3000001,
        maxYellow: 0.5,
    },
    // Márgenes (en %).
    margenBrutoPct: {
        minGreen: 50,
        maxGreen: Infinity,
        minYellow: 35,
        maxYellow: 49.9999999,
    },
    ebitdaMarginPct: {
        minGreen: 15,
        maxGreen: Infinity,
        minYellow: 5,
        maxYellow: 14.9999999,
    },
    netMarginPct: {
        minGreen: 8,
        maxGreen: Infinity,
        minYellow: 2,
        maxYellow: 7.9999999,
    },
    // Crecimiento (en %): green > 0, red <= 0.
    salesGrowth: {
        minGreen: 0.0000001,
        maxGreen: Infinity,
    },
};
//# sourceMappingURL=accounting-semaforo.js.map